import './apm';

import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@oscar/theme';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import Root from './views/layout/Root';
import reportWebVitals from './reportWebVitals';
import store from './store';
import '@oscar/theme/dist/theme.css';
import './styles/index.scss';

const persistor = persistStore(store);

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Root />
        </PersistGate>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
